type MapAddressDataResult = {
  [key: string]: string;
};

export const mapAddressData = (
  placeData: google.maps.places.PlaceResult
): MapAddressDataResult => {
  const { address_components = [] } = placeData;
  const billingAddressAddressLine1: string[] = [];
  const billingAddressZip: string[] = [];
  address_components?.forEach((addressComponent) => {
    if (
      addressComponent.types.includes("street_number") ||
      addressComponent.types.includes("route")
    ) {
      billingAddressAddressLine1.push(addressComponent.short_name);
    } else if (addressComponent.types.includes("postal_code")) {
      billingAddressZip.push(addressComponent.short_name);
    }
  });

  return {
    billingAddressAddressLine1: billingAddressAddressLine1.join(" "),
    billingAddressAdministrativeArea:
      processAdministrativeAreaByCountry(address_components),
    billingAddressCity: processCityByCountry(address_components),
    billingAddressZip: billingAddressZip.join(" "),
    billingAddressCountry: getCountryCode(address_components),
  };
};

export const processAdministrativeAreaByCountry = (
  addressComponent: google.maps.places.PlaceResult["address_components"]
): string => {
  let adminArea = "";
  // Default is use admin level 1
  let adminAreaTypeValue = "administrative_area_level_1";
  // List of all the countries that have special type requirements and the type it should be derived from
  const countriesWhereProvinceIsAlternativeType: Record<string, string> = {
    GB: "administrative_area_level_2",
  };

  // Get the current address country
  const country =
    addressComponent?.filter((record) => {
      return record.types.includes("country");
    })[0]?.short_name || "";

  // check if current country has an override record, and get key
  if (Object.hasOwn(countriesWhereProvinceIsAlternativeType, country)) {
    adminAreaTypeValue = countriesWhereProvinceIsAlternativeType[country];
  }

  // Get value via the mapped type to return
  adminArea =
    addressComponent?.filter((record) => {
      return record.types.includes(adminAreaTypeValue);
    })[0]?.short_name || "";

  return adminArea;
};

const getCountryCode = (
  addressComponent: google.maps.places.PlaceResult["address_components"]
): string => {
  return (
    addressComponent?.filter((record) => {
      return record.types.includes("country");
    })[0]?.short_name || ""
  );
};

export const processCityByCountry = (
  addressComponent: google.maps.places.PlaceResult["address_components"]
): string => {
  let city = "";
  // Default is use admin level 1
  let cityTypeValue = "locality";
  // List of all the countries that have special type requirements and the type it should be derived from
  const countriesWhereCityIsAlternativeType: Record<string, string> = {
    GB: "postal_town",
  };

  // Get the current address country
  const country = getCountryCode(addressComponent);

  // check if current country has an override record, and get key
  if (Object.hasOwn(countriesWhereCityIsAlternativeType, country)) {
    cityTypeValue = countriesWhereCityIsAlternativeType[country];
  }

  // Get value via the mapped type to return
  city =
    addressComponent?.filter((record) => {
      return record.types.includes(cityTypeValue);
    })[0]?.short_name || "";

  return city;
};

//
// {
//   "long_name" : "London",
//   "short_name" : "London",
//   "types" : [ "postal_town" ]
// },
